'use strict';

// --- Popper (required) ---

import '@popperjs/core/dist/esm/index.js';

// --- Bootstrap (full) ---

import 'bootstrap';

// --- Bootstrap (components) ---

// import Alert from 'bootstrap/js/dist/alert';
// import Button from 'bootstrap/js/dist/button';
// import Carousel from 'bootstrap/js/dist/carousel';
//import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
// import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Popover from 'bootstrap/js/dist/popover';
// import ScrollSpy from 'bootstrap/js/dist/scrollspy';
// import Tab from 'bootstrap/js/dist/tab';
// import Toast from 'bootstrap/js/dist/toast';
// import Tooltip from 'bootstrap/js/dist/tooltip';

// --- Popovers ---

var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl)
})

const popupBtns = document.querySelectorAll('a[href="#poptat"]');

if (popupBtns) {
    popupBtns.forEach(popupBtn => popupBtn.addEventListener('click', function (e) {
        var contactModalElement = document.getElementById('contactModal');
        var contactModal = new Modal(contactModalElement, {});

        contactModal.show();
    }));
}